import { useQueries } from '@tanstack/react-query'
import { useMemo } from 'react'
import { User } from '../../../types/user/User'
import { fetchCompanyUsers } from '../service/userService'
import userQueryKeys from './userQueryKeys'

// No bulk "users for a group of companies" endpoint exists — fans out one
// GET /companies/{id}/users request per company and merges the results.
export const useGroupUsers = (companyIds: string[]): User[] => {
  const results = useQueries({
    queries: companyIds.map(companyId => ({
      queryKey: userQueryKeys.companyUsers(companyId),
      queryFn: fetchCompanyUsers,
      enabled: !!companyId,
      staleTime: 5 * 60 * 1000
    }))
  })

  return useMemo(() => {
    const byId = new Map<number, User>()
    results.forEach(result => result.data?.forEach(user => byId.set(user.id, user)))
    return Array.from(byId.values())
  }, [results])
}
